import request from './request.js'
import requestsNoLoad from './requests.js'

// user/insert   users保存
export function insertUser(data){
  return request({
    url: 'user/insert',
    method: 'post',
    params: data
  });
}
//user/getData  页面所有数据
export function getUser(data){
  return request({
    url: 'user/getData',
    method: 'post',
    params: data
  });
}

// user/update   更新
export function updateUser(data){
  return request({
    url: 'user/update',
    method: 'post',
    params: data
  });
}
// user/delete  删除
export function deleteUser(data){
  return request({
    url: 'user/delete',
    method: 'post',
    params: data
  });
}
// /user/resetPassword  密码重置
export function resetPassword(data){
  return request({
    url: 'user/resetPassword',
    method: 'post',
    params: data
  });
}

// userid   roleid
export function updateUserRole(data){
  return request({
    url: 'userrole/update',
    method: 'post',
    params: data
  });
}

// user/replaceLogin   替身登录接口
export function replaceLogin (data){
  return request({
    url: 'user/replaceLogin',
    method: 'post',
    params: data
  });
}

// 得到维护信息
export function getMaintenance(data) {
  return request({
      url: 'systemSetting/getMaintenance',
      method: 'post',
      params: data    
  });
}

// 验证邮箱的接口
export function getVerificationcode(data) {
  return request({
      url: 'user/getVerificationcode',
      method: 'post',
      params: data    
  });
}

// 登录接口
export function userLogin(data) {
  return request({
    url: 'user/login',
    method: 'post',
    params: data
  });
}
// 修改密码/user/modifyPassword

export function modifyPassword(data) {
  return request({
    url: 'user/modifyPassword',
    method: 'post',
    params: data
  });
}

// 退出接口
export function logout(data) {
  return request({
    url: 'user/logout',
    method: 'post',
    params: data
  });
}

// user/getLocalStorage
export function getSelectOptionList(data){
  return request({
    url: 'user/getSelectOptionList',
    method: 'post',
    params: data
  });
}

// /userlicense/insert 授权
export function insertUserLicense(data){
  return request({
    url: 'userlicense/insert',
    method: 'post',
    params: data
  });
}
// /userLicense/delete 解除授权
export function deleteUserLicense(data){
  return request({
    url: 'userlicense/delete',
    method: 'post',
    params: data
  });
}
// /userLicense/getData 授权列表
export function getUserLicense(data){
  return request({
    url: 'userlicense/getData',
    method: 'post',
    params: data
  });
}

// user/forgoPassword 重置验证码
export function userForgoPassword(data) {
  return request({
      url: 'user/forgotPassword',
      method: 'post',
      params: data    
  });
}
// user/forgoResetPassword  重置密码
export function userForgoResetPassword(data) {
  return request({
      url: 'user/forgotResetPassword',
      method: 'post',
      params: data    
  });
}

// 下载登录接口
export function userDownloadVerify(data) {
  return request({
    url: 'user/downloadVerify',
    method: 'post',
    params: data
  });
}

export function replaceLoginForAgent(data) {
  return request({
    url: 'user/replaceLoginForAgent',
    method: 'post',
    params: data
  });
}

export function unlockUser(data) {
  return request({
    url: 'user/unlock',
    method: 'post',
    params: data
  });
}

export function getLockUserData(data) {
  return request({
    url: 'user/getLockUserData',
    method: 'post',
    params: data
  });
}

export function unlockResetUserPassword(data) {
  return request({
    url: '/user/unlockResetPassword',
    method: 'post',
    params: data
  });
}

export function setAdminUserPassword(data) {
  return request({
    url: 'user/setPassword',
    method: 'post',
    params: data
  });
}

export function getSpecificUser(data){
  return request({
    url: 'user/getUser',
    method: 'post',
    params: data
  });
}

export function updateUserByUserID(data){
  return request({
    url: 'user/updateUserByUserID',
    method: 'post',
    params: data
  });
}

export function insertLoginInfo(data) {
  return request({
    url: 'user/insertLoginInfo',
    method: 'post',
    params: data    
  });
}

export function getSettingsData(data){
  return requestsNoLoad({
    url: "userSettings/getData",
    method: 'post',
    params: data
  });
}

export function updateSettingsData(data){
  return requestsNoLoad({
    url: "userSettings/update",
    method: 'post',
    params: data
  });
}




// WEBPACK FOOTER //
// ./src/api/userApi.js